import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { 
    CircleCheck,
    Clock,
    Mail,
    Plus
 } from "lucide-react";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import PopupButton from "components/button/PopupButton";
import MessageTicket from "./components/MessageTicket";
import EmployeeInboxTabs from "./components/EmployeeInboxTabs";
import DepartmentGridCard from "./components/DepartmentCardGrid";
import {
    getTicketList 
} from "../../../../../redux/ticket/ticketState";
import {
    getClientTeamList
} from "../../../../../redux/optionlist/optionlistState";

const getStatusDisplay = (status) => ({
    "open": "pending",
    "in progress": "responded",
    "resolved": "resolved"
}[status] || "pending");

const EmployeeInbox = () => {
    const dispatch = useDispatch();

    const authUser = useSelector((state) => state.auth.user);

    const recordList = useSelector((state) => state.ticket.ticketList?.items || []);
    const pagination = useSelector((state) => state.ticket.ticketList?.pagination);
    const departmentList = useSelector((state) => state.optionlist.clientTeamList?.items || []);


    const [selectedDepartment, setSelectedDepartment] = useState("All");

    const mainTickets = recordList.filter(t => !t.tic_parent_id);

    const total = mainTickets.length;
    const pending = mainTickets.filter(t => t.ticket_status === 'open').length;
    const resolved = mainTickets.filter(t => t.ticket_status === 'resolved').length;

    useEffect(() => {
        dispatch(getTicketList({
            paginate: pagination?.per_page,
        }));
    }, [dispatch, pagination?.per_page]);


    useEffect(() => {
        if (authUser) {
            dispatch(getClientTeamList({
                clientId: authUser.client_id ?? 0,
            }));
        }
    }, [dispatch, authUser]);

    return (
        <div className="grid grid-cols-1">
            <div className="space-y-6 max-w-[1800px]">
                <SummaryHeader
                    title={"My Inbox"}
                    icon={Mail}
                    description={"Connect with Hyvid departments for support and assistance"}
                    color={"bg-emerald"}
                    rightNav={
                        <PopupButton 
                            id="add_ticket" 
                            title="Contact Hyvid Department"
                            description="Send a message to any Hyvid department for support and assistance"
                            label="New Message" 
                            btnClass="ticket btn-ticket white" 
                            action="add"
                            moduleId={0}
                            icon={Plus}
                            useCustomClass={true}
                            modalWidth={500}
                        >
                            <MessageTicket recordId="0" mode="edit"/>
                        </PopupButton>
                    }
                >
                   <div className="summary-item-container">
                        <SummaryItem
                            title="Total Messages"
                            icon={<Mail />}
                            display={total}
                        />
                        <SummaryItem
                            title="Pending"
                            icon={<Clock />}
                            display={pending} 
                        />
                        <SummaryItem
                            title="Resolved"
                            icon={<CircleCheck />}
                            display={resolved}
                        />
                   </div>
                </SummaryHeader>
                <DepartmentGridCard        
                    messages={recordList}
                    selectedDepartment={selectedDepartment}
                    onSelectDepartment={setSelectedDepartment}
                    departmentOptions={departmentList}
                />
                <EmployeeInboxTabs 
                    messages={recordList}
                    selectedDepartment={selectedDepartment}
                    getStatusDisplay={getStatusDisplay}
                />
            </div>
        </div>
    )
};

export default EmployeeInbox;